module.exports = __webpack_public_path__ + "static/media/BoardDetail_test2.e153effe.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Direction/assets/BoardDetail_test2.jpeg
// module id = 571
// module chunks = 0